<template>
  <div
    :style="style"
    class="sticky top-0 z-50 py-3 bg-color text-color shadow-sm"
    role="banner"
  >
    <div class="px-6 flex mx-auto" :class="{ container: !isModalMode }">
      <div v-if="hasLogo" class="flex items-center flex-1">
        <img
          :src="$store.state.config.logo.src"
          :width="$store.state.config.logo.width"
          :height="$store.state.config.logo.height"
          class="max-w-full mx-auto md:mx-0"
          alt="Company Logo"
        />
      </div>
      <div v-if="!isIframe" class="hidden ml-auto md:flex md:items-center">
        <button
          type="button"
          class="ml-auto text-gray-400"
          aria-label="Close"
          @click.prevent="$emit('close')"
        >
          <svg-close width="18" height="18" aria-hidden="true" role="img" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import SvgClose from "@/components/Svg/SvgClose";

export default {
  props: ["config"],
  components: {
    SvgClose,
  },
  computed: {
    isIframe() {
      return this.$store.state.config?.iframeMode;
    },
    hasLogo() {
      return (
        this.$store.state.config?.showLogo &&
        this.$store.state.config?.logo?.src
      );
    },
    style() {
      return {
        "--bg-color":
          this.$store.state.config.colors.headerBackground || "#FFFFFF",
        "--color": this.$store.state.config.colors.headerColor || "#212127",
      };
    },
    isModalMode() {
      return this.$store.state.config?.modalMode;
    },
  },
};
</script>

<style scoped>
.bg-color {
  background-color: var(--bg-color);
}
.text-color {
  color: var(--color);
}
</style>
